import React from "react";
import { MenuItem, FormControl, Select, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 130,
    },
    menuItemScroll: {
        maxHeight: "200px",
        overflowY: "auto",
    },
}));

export const OrderHistoryFilter = ({
    language,
    listName,
    consumerName,
    listNames,
    consumerNames,
    setListName,
    setConsumerName,
}) => {
    const classes = useStyles();

    return (
        <div className="d-flex align-items-center">
            <FormControl className={classes.formControl}>
                <Select
                    MenuProps={{
                        classes: { paper: classes.menuItemScroll },
                    }}
                    variant="outlined"
                    margin="dense"
                    value={listName}
                    displayEmpty
                    onChange={(e) => setListName(e.target.value)}
                >
                    <MenuItem value="">
                        {language.CCMODE_SHORTLISTPAGE_SHORTLISTNAME}
                    </MenuItem>
                    {listNames.map((name) => (
                        <MenuItem key={name} value={name}>
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <FormControl className={classes.formControl}>
                <Select
                    MenuProps={{
                        classes: { paper: classes.menuItemScroll },
                    }}
                    variant="outlined"
                    margin="dense"
                    value={consumerName}
                    displayEmpty
                    onChange={(e) => setConsumerName(e.target.value)}
                >
                    <MenuItem value="">
                        {language.CCMODE_THEME3_CONSUMERNAME}
                    </MenuItem>
                    {consumerNames.map((name) => (
                        <MenuItem key={name} value={name}>
                            {name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};